import React from 'react'
import RichText from 'src/utils/RichText'
import Heading from 'src/utils/Heading'
import Button from 'src/utils/Button'
import TBBImage from 'utils/TBBImage'

const Hero = ({ blok }) => {
    return (
        <div className="bg-white">
            <div className="max-w-7xl mx-auto my-16 px-8">
                <Heading size="h1">Heading 1</Heading>
                <Heading size="h2">Heading 2</Heading>
                <Heading size="h3">Heading 3</Heading>
                <Heading size="h4">Heading 4</Heading>
                <Heading size="h5">Heading 5</Heading>
                <Heading size="h6">Heading 6</Heading>
                <Button
                    to={blok.button_target.cached_url}
                    className="bg-red-600 mr-1"
                >
                    {blok.button_text}
                </Button>
                <Button
                    to={'www.google.com'}
                    target="_blank"
                    className="bg-red-500 mr-1"
                >
                    External button
                </Button>
                <Button
                    className="bg-red-400"
                >
                    div button
                </Button>
                <TBBImage
                    fixed
                    image={{filename: 'https://a.storyblok.com/f/114196/934x1401/ae68064fb5/photo-1507207611509-ec012433ff52.jpeg'}}
                    className="!block !w-full my-6"
                />
                <div className="prose mt-12">
                    <RichText>{blok.main_content}</RichText>
                </div>
            </div>
        </div>
    )
}

export default Hero